// =============================================================
// FOOTER
// =============================================================

import { COPY } from "@/features/landing/content/landing-copy";
import styles from "./Footer.module.css";

interface RootProps { children?: never; }

function Root(_: RootProps) {
  return (
    <footer className={styles.colophon} role="contentinfo">
      <div className={styles["colophon__inner"]}>
        <div className={styles["colophon__top"]}>
          <div className={styles["colophon__brand"]}>
            <img
              className={styles["colophon__brand-logo"]}
              src="/img/logo.png"
              alt="Fuar Cafe Catering Services"
              width={816}
              height={428}
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className={styles.colophon__col}>
            <h3>Adres</h3>
            <ul>
              {COPY.colophon.address.map((s) => (<li key={s}>{s}</li>))}
            </ul>
          </div>

          <div className={styles.colophon__col}>
            <h3>İletişim</h3>
            <ul>
              <li><a href="tel:+905324403696">0532 440 36 96</a></li>
              <li><a href="mailto:info@fuarcafe.example">info@fuarcafe.example</a></li>
            </ul>
          </div>

          <div className={styles.colophon__col}>
            <h3>Sosyal</h3>
            <ul>
              <li><a href="#" aria-label="Instagram">Instagram</a></li>
              <li><a href="https://facebook.com/fuarcafe" aria-label="Facebook" target="_blank" rel="noopener noreferrer">Facebook</a></li>
              <li><a href="https://wa.me/905324403696" aria-label="WhatsApp">WhatsApp</a></li>
            </ul>
          </div>
        </div>

        <div className={styles["colophon__bottom"]}>
          <span>{COPY.colophon.legal}</span>
          <span className={styles["colophon__seal"]}>
            <span className={styles["colophon__seal-mark"]} aria-hidden="true" />
            {COPY.colophon.seal}
          </span>
          <a
            href={COPY.colophon.attribution.href}
            target="_blank"
            rel="noopener noreferrer"
            className={styles["colophon__attribution"]}
          >
            {COPY.colophon.attribution.label}
            <span className={styles["colophon__attribution-arrow"]} aria-hidden="true">↗</span>
          </a>
          <span>{COPY.colophon.locale}</span>
        </div>
      </div>
    </footer>
  );
}

export const Footer = { Root };
